import { Head } from '@inertiajs/inertia-vue3';
import Layout from '@/Shared/Layout';
import TextInput from '@/Shared/TextInput';
export default {
  components: {
    Head: Head,
    TextInput: TextInput
  },
  layout: Layout,
  props: {
    reachOutDataProp: Object,
    lastUpdated: String
  },
  data: function data() {
    return {
      reachOutData: this.reachOutDataProp,
      search: ""
    };
  },
  computed: {
    filterTableData: function filterTableData() {
      var _this = this;
      return this.reachOutData.filter(function (data) {
        return !_this.search || data.tenant_id.toLowerCase().includes(_this.search.toLowerCase());
      });
    }
  }
};